import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminHours() {
  const [items, setItems] = useState([]);
  const { toast } = useToast();
  useEffect(() => { api.get('/hours').then((r) => setItems(r.data)); }, []);

  const save = async (h) => {
    try {
      await api.put(`/admin/hours/${h.id}`, { day: h.day, time: h.time, order: h.order });
      toast({ title: 'Saved', description: `${h.day} — ${h.time}` });
    } catch (err) {
      toast({ title: 'Error', description: 'Save failed' });
    }
  };

  const update = (id, key, val) => setItems((cur) => cur.map((h) => h.id === id ? { ...h, [key]: val } : h));

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl text-[#0F1C2E] mb-6">Opening Hours</h1>
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        {items.map((h) => (
          <div key={h.id} className="grid grid-cols-[140px_1fr_auto] gap-3 items-center px-6 py-3 border-b border-gray-50 last:border-b-0">
            <div className="font-semibold text-[#0F1C2E]">{h.day}</div>
            <input value={h.time} onChange={(e) => update(h.id, 'time', e.target.value)} className="rounded-xl border border-gray-200 px-3 py-2 focus:outline-none focus:border-[#ED2E2E] focus:ring-2 focus:ring-[#ED2E2E]/20" />
            <button onClick={() => save(h)} className="btn-wrappus text-xs px-4 py-2"><Save size={14} /> Save</button>
          </div>
        ))}
      </div>
    </div>
  );
}
